import { module as BaseModule } from 'modujs'
import Player from '@vimeo/player'
import {
  exitFullscreen, iOS, isSafariDesktop,
  launchIntoFullscreen,
} from '../utils/dom'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.isPlaying = false
    this.isFullscreen = false

    this.$container = this.el
    this.$playButton = this.$('play')[0]
    this.$iframe = this.$('player')[0]
  }

  init() {
    if (!this.$iframe) return

    this.video = new Player(this.$iframe)

    document.addEventListener('fullscreenchange', () => {
      this.toggleFullscreen()
    })

    this.$playButton?.addEventListener('click', () => {
      launchIntoFullscreen(this.video)
    })
  }

  toggleFullscreen() {
    if (this.isFullscreen) {
      this.leaveFullscreen()
    } else {
      this.enterFullscreen()
    }
  }

  enterFullscreen() {
    // if (iOS || isSafariDesktop) {
    //   this.video.requestFullscreen()
    //     .then(() => {
    //       this.$container.classList.add('is-fullscreen')
    //     })
    //     .catch((error) => {
    //       throw new Error(`enterFullscreen – ${error}`)
    //     })
    //   /* return */
    // }

    this.isFullscreen = true
    this.video.play()
    this.$container.classList.add('is-fullscreen')
  }

  leaveFullscreen() {
    // if (iOS || isSafariDesktop) {
    //   this.video.exitFullscreen()
    //     .then(() => {
    //       this.$container.classList.remove('is-fullscreen')
    //     })
    //     .catch((error) => {
    //       throw new Error(`leaveFullscreen – ${error}`)
    //     })
    //   // return
    // }

    // exitFullscreen()
    this.isFullscreen = false
    this.video.pause()
    this.$container.classList.remove('is-fullscreen')
  }
}
